export default function SupplierTermsOfService() {
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service - Wedding Suppliers</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700 leading-relaxed">
            By registering as a wedding supplier on PhilTrade, you agree to be bound by these Terms of Service. 
            These terms govern your use of our platform and participation in wedding supplier exhibits.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Supplier Responsibilities</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-medium text-gray-700">2.1 Professional Standards</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Maintain high professional standards in all client interactions</li>
              <li>Provide accurate and truthful information about your services</li>
              <li>Deliver services as promised and within agreed timeframes</li>
              <li>Maintain appropriate business licenses and insurance</li>
            </ul>

            <h3 className="text-lg font-medium text-gray-700">2.2 Exhibit Participation</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Arrive on time for scheduled exhibits and events</li>
              <li>Maintain a professional appearance and booth presentation</li>
              <li>Respect other suppliers and exhibit guidelines</li>
              <li>Follow all venue rules and regulations</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Service Quality</h2>
          <p className="text-gray-700 leading-relaxed">
            As a wedding supplier, you are responsible for the quality of services provided to clients. 
            PhilTrade reserves the right to review and, if necessary, remove suppliers who fail to meet 
            professional standards or receive consistent negative feedback.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Payment and Fees</h2>
          <div className="space-y-3">
            <p className="text-gray-700 leading-relaxed">
              Exhibit participation fees and payment terms will be clearly communicated during the registration process. 
              All fees are non-refundable unless otherwise specified.
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Payment is due before exhibit participation</li>
              <li>Late payments may result in booth reassignment</li>
              <li>Refunds are subject to our cancellation policy</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Intellectual Property</h2>
          <p className="text-gray-700 leading-relaxed">
            You retain ownership of your intellectual property, including portfolio images, service descriptions, 
            and business materials. By using our platform, you grant PhilTrade a license to display your 
            information for marketing and promotional purposes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Client Relationships</h2>
          <div className="space-y-3">
            <p className="text-gray-700 leading-relaxed">
              While PhilTrade facilitates connections between suppliers and clients, the business relationship 
              is directly between you and your clients. You are responsible for:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Contract negotiations and terms</li>
              <li>Service delivery and quality</li>
              <li>Payment collection from clients</li>
              <li>Customer service and dispute resolution</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Termination</h2>
          <p className="text-gray-700 leading-relaxed">
            Either party may terminate this agreement at any time. PhilTrade reserves the right to 
            immediately suspend or terminate supplier accounts for violations of these terms or 
            inappropriate conduct.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Limitation of Liability</h2>
          <p className="text-gray-700 leading-relaxed">
            PhilTrade is not liable for any damages arising from supplier-client relationships, 
            service delivery issues, or business disputes. Suppliers participate at their own risk.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Contact Information</h2>
          <p className="text-gray-700 leading-relaxed">
            For questions about these terms or your supplier account, please contact us at 
            <a href="mailto:support@philtrade.com" className="text-orange-600 hover:text-orange-700">
              support@philtrade.com
            </a>
          </p>
        </section>
      </div>
    </div>
  )
}
